module.exports = __webpack_public_path__ + "img/w3_search_grey.24e427d0.png";